import Vue from "vue";

export class CaixaEmenda {
    static create() {
        return {
            nome: null,
            obs: null,
            place: [0, 0]
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixa-emenda/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("caixa-emenda/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixas-emendas")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("caixa-emenda/" + data._id, data);
            } else {
                promisse = Vue.http.post("caixa-emenda/0", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
